import CryptoJS from "crypto-js";

function processCardNumber(cardNumber) {
  const hashedCard = CryptoJS.SHA256(cardNumber).toString(CryptoJS.enc.Hex);
  const blurryNumber = "*".repeat(cardNumber.length - 3) + cardNumber.slice(-3);
  return { hashNumber: hashedCard, blurryNumber };
}

export default processCardNumber;
